import { useSelector } from 'react-redux';

function useSubscription() {
	const user = useSelector((state) => state.userInfo?.userInfo?.data);
	const subscription = user?.subscription;
	const isSubscribed = user?.is_subscribed;
	const isSubscriptionFree = subscription?.is_free;
	const isSubscriptionActive = subscription?.is_active;
	const isSubscriptionExpired = subscription?.is_expired;
	const isSubscriptionRecurring = subscription?.is_recurring;
	const subscriptionBillingPeriod = subscription?.billing_period;
	const subscriptionPaymentMethod = subscription?.payment_details?.method;
	const subscriptionScheduledForCancellation = subscription?.is_scheduled_for_cancellation;
	const subscriptionNextBillingDate = subscription?.next_billing_date;
	const subscriptionStatus = subscription?.status;
	const isSubscriptionPaused = subscription?.status === 'Paused';
	const isSubscriptionCancelled = subscription?.status === 'Cancelled';
	// Backend returns the human display status (getDisplayStatus), not the raw
	// enum — 'created'/'authenticated' both surface as 'Payment Pending'.
	const isPendingPayment = subscription?.status === 'Payment Pending';

	return {
		subscription,
		isSubscribed,
		isSubscriptionFree,
		subscriptionStatus,
		isSubscriptionRecurring,
		isSubscriptionExpired,
		isSubscriptionActive,
		subscriptionBillingPeriod,
		subscriptionPaymentMethod,
		subscriptionScheduledForCancellation,
		subscriptionNextBillingDate,
		isSubscriptionPaused,
		isSubscriptionCancelled,
		isPendingPayment,
	};
}

export default useSubscription;
